var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import PropTypes from "prop-types";
import { IconBack, IconMoreHorizontal, IconNext, IconPrevious } from "../../icons";
import classNames from "classnames";
var Page = function (_a) {
    var pageNum = _a.pageNum, children = _a.children, onClick = _a.onClick, _b = _a.className, className = _b === void 0 ? "" : _b;
    var handleOnClick = function () {
        onClick === null || onClick === void 0 ? void 0 : onClick(pageNum);
    };
    return (_jsx("div", __assign({ className: "mex-pagination__page ".concat(className), onClick: handleOnClick }, { children: children })));
};
var Pagination = function (_a) {
    var current = _a.current, _b = _a.pageSize, pageSize = _b === void 0 ? 10 : _b, showTotal = _a.showTotal, total = _a.total, onChange = _a.onChange;
    var onPageClick = function (page) {
        onChange === null || onChange === void 0 ? void 0 : onChange(page);
        setCurrentPage(page);
    };
    var totalPage = parseInt("".concat(Math.ceil(total / pageSize)), 10);
    var _c = useState(current || 1), currentPage = _c[0], setCurrentPage = _c[1];
    var getCurrentPage = function () { return (current ? current : currentPage); };
    var createPages = function () {
        var pages = [
            _jsx(Page, __assign({ pageNum: 1, onClick: onPageClick }, { children: _jsx(IconPrevious, { size: "sm" }) }), "first"),
            _jsx(Page, __assign({ pageNum: getCurrentPage() - 1 || 1, onClick: onPageClick }, { children: _jsx(IconBack, { size: "sm" }) }), "back"),
            _jsx(Page, __assign({ pageNum: getCurrentPage() + 1 > totalPage ? totalPage : getCurrentPage() + 1, onClick: onPageClick }, { children: _jsx(IconBack, { size: "sm", style: { transform: "rotate(180deg)" } }) }), "next"),
            _jsx(Page, __assign({ pageNum: totalPage, onClick: onPageClick }, { children: _jsx(IconNext, { size: "sm" }) }), "last"),
        ];
        var createPageButton = function (number, isSkip, isCurrent) {
            var pageClassNames = classNames({
                "mex-pagination__page--current": isCurrent,
                "mex-pagination__page--skip": isSkip,
            });
            var pageNode = (_jsx(Page, __assign({ className: pageClassNames, pageNum: number, onClick: isSkip ? undefined : onPageClick }, { children: isSkip ? _jsx(IconMoreHorizontal, {}) : number }), number));
            pages.splice(-2, 0, pageNode);
        };
        var morePages = { prev: false, next: false };
        for (var i = 1; i <= totalPage; i++) {
            var DISTANCE_PAGE = 3;
            if (i > getCurrentPage() - DISTANCE_PAGE && i < getCurrentPage() + DISTANCE_PAGE) {
                createPageButton(i, false, i === getCurrentPage());
            }
            else if (i < getCurrentPage() + DISTANCE_PAGE && !morePages.prev) {
                createPageButton(i, true, false);
                morePages.prev = true;
            }
            else if (i > getCurrentPage() - DISTANCE_PAGE && !morePages.next) {
                createPageButton(i, true, false);
                morePages.next = true;
            }
        }
        return pages;
    };
    var getRange = function () {
        var lastNum = getCurrentPage() * pageSize;
        return [(getCurrentPage() - 1) * pageSize + 1, lastNum > total ? total : lastNum];
    };
    return (_jsxs("div", __assign({ className: "mex-pagination" }, { children: [showTotal && _jsx("div", { children: showTotal(total, getRange()) }), createPages()] })));
};
Pagination.propTypes = {
    pageSize: PropTypes.number,
    showTotal: PropTypes.func,
    total: PropTypes.number.isRequired,
    current: PropTypes.number,
    onChange: PropTypes.func,
};
Pagination.defaultProps = {
    pageSize: 10,
};
export default Pagination;
